import R from 'ramda';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Form, FormGroup } from 'react-bootstrap';
import Select from '../Select';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';

class InviteMember extends Component {
  constructor(props) {
    super(props);
    this.state = {
      members: [],
      inviteId: '',
    };
  }

  componentWillReceiveProps(nextProps) {
    const { status } = nextProps;

    if (this.props.status !== status) {
      if (status === actionTypes.RESEND_DEAL_INVITATION_ERROR) {
        this.setState({ loading: false });
        this.props.alert(
          'error',
          'Oops! Something went wrong. Please try again. If this error persists, please contact us.'
        );
      } else if (status === actionTypes.RESEND_DEAL_INVITATION_SUCCESS) {
        this.setState({ loading: false });
        this.close();
      }
    }
  }

  opened = () => {
    const { profile, invites } = this.props;
    const members = R.filter(
      (invitee) => invitee.email !== profile.email,
      invites
    );
    this.setState({ members });
  };

  close = () => {
    this.props.onClose();
  };

  save = (e) => {
    e.preventDefault();
    this.props.hideAlert();

    const { deal } = this.props;
    const { inviteId } = this.state;

    if (inviteId !== '') {
      this.setState({ loading: true }, () => {
        this.props.onResendDealInvitation(deal.id, inviteId);
      });
    }
  };

  handlechange(e) {
    this.setState({ inviteId: e.target.value });
  }

  render() {
    const { members, inviteId, loading } = this.state;

    return (
      <Modal
        className="invite-member-modal"
        show={this.props.show}
        onEnter={this.opened}
        onHide={this.close}
      >
        <Modal.Header closeButton>
          <Modal.Title>Resend Invitations</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={this.save}>
            <p>Choose a collaborator to re-invite to this agreement:</p>
            <FormGroup>
              <Select
                className="form-control"
                required
                value={inviteId}
                onChange={(e) => this.handlechange(e)}
              >
                <option value="">select</option>
                {members.map((member, index) => (
                  <option key={index} value={member.id}>
                    {member.email}
                  </option>
                ))}
              </Select>
            </FormGroup>
            <br />
            <FormGroup className="text-center">
              <button type="submit" disabled={loading}>
                {loading && (
                  <i className="fa fa-refresh fa-spin fa-fw mr-5px"></i>
                )}
                Resend Invitation
              </button>
            </FormGroup>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  status: state.invites.status,
  profile: state.profile,
  invites: state.invites.invites,
  deal: state.deals.selectedDeal,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  onResendDealInvitation: (dealId, inviteId) => {
    dispatch(actions.resendDealInvitation(dealId, inviteId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(InviteMember);



// WEBPACK FOOTER //
// src/components/Deals/InviteMember.jsx